module.exports = __webpack_public_path__ + "assets/img/online_wechat.c3b7178d.svg";